import Promise from 'bluebird';

import {React, Page, TopBanner, HBox, VBox} from './Page';
import {Skype} from '../icons';

const debug = require('debug')('pointblank:playground');


export default class Playground extends Page {

  manualAsync() {
    this.props.data.cursor('popup').set({
      icon: Skype,
      message: 'Что-то произошло после пользовательского решения',
      action: 'Закрыть это окно',
      onAction: this.asyncAction.bind(this)
    });
  }

  async asyncAction() {
    debug('async action');
    await Promise.delay(1000);
    debug('async action finish');
    this.props.data.cursor(['popup', 'close']).set(true);
  }

  autoSync() {
    this.props.data.cursor('popup').set({
      icon: Skype,
      message: 'Что-то произошло после пользовательского решения',
      action: 'Закрыть вон то окно',
      autoClose: true,
      onAction: function() {
        debug('sync action');
      }
    });
  }

  emitError() {
    call_unknown_function();
  }

  promiseError() {
    new Promise(function(resolve, reject) {
      resolve();
    }).then(function() {
      call_unknown_function();
    });
  }

  renderLoaded() {
    return (
      <div className='Playground'>
        <TopBanner size='tiny' data={this.props.data} />
        <VBox width={4}>
          <HBox width={4}>
            <VBox width={2}>
              <HBox width={2} style={{background: 'rgba(255, 0,0,0.1)', cursor: 'pointer'}} onClick={this.manualAsync.bind(this)}>
                manual async popup
              </HBox>
              <HBox width={2} style={{background: 'rgba(255, 0,0,0.1)', cursor: 'pointer'}} onClick={this.autoSync.bind(this)}>
                sync popup
              </HBox>
              <HBox width={2} style={{background: 'rgba(255, 0,0,0.5)', cursor: 'pointer'}} onClick={this.emitError.bind(this)}>
                emit error
              </HBox>
            </VBox>
            <VBox width={2}>
              <HBox width={2} style={{background: 'rgba(0,255,0,0.1)', cursor: 'pointer'}} onClick={this.promiseError.bind(this)}>
                unhandled promise rejection
              </HBox>
              <HBox width={2} style={{background: 'rgba(0,255,0,0.3)'}}>2</HBox>
              <HBox width={2} style={{background: 'rgba(0,255,0,0.5)'}}>3</HBox>
            </VBox>
          </HBox>
          <HBox width={4} style={{background: 'rgba(0,0,255, 0.3)'}}>
            123
          </HBox>
        </VBox>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/pages/Playground.js